/* Cart drawer extras: shipping protection tick, removal of orphan extras, bundle perks (free gift card + warranty).
   Perks are products with a "Free with bundle" ($0) and a "Standard" ($10) variant. With 2+ bundle items in the cart the line is the free
   variant; under 2 the perk lines are removed (swap entries with variant 0 mean remove only). The drawer markup carries data-ai-perks (swap = key|variantId;..., add = variantId,..). */
(function () {
  if (window.__aiDrawer) return; window.__aiDrawer = 1;
  var HDR = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var SECS = 'cart-drawer,cart-icon-bubble';
  var EXTRA = /shipping-protection|bonus-gift-card|extended-warranty/;
  function render(state) {
    var cd = document.querySelector('cart-drawer');
    if (state && state.sections && cd && cd.renderContents) { cd.renderContents(state); } else { window.location.reload(); }
  }
  function call(url, body) {
    body.sections = SECS; body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: HDR, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  document.addEventListener('change', function (e) {
    var cb = e.target; if (!cb || !cb.closest) return;
    var root = cb.closest('.ai-ship-d'); if (!root || cb.type !== 'checkbox') return;
    var vid = parseInt(root.getAttribute('data-vid'), 10), want = cb.checked;
    cb.disabled = true; root.classList.add('is-busy'); root.classList.toggle('is-on', want);
    var req = want ? call('/cart/add.js', { items: [{ id: vid, quantity: 1 }] }) : call('/cart/change.js', { id: String(vid), quantity: 0 });
    req.then(function (s) { if (s && s.status) throw new Error('cart'); render(s); })
      .catch(function () { cb.checked = !want; root.classList.toggle('is-on', !want); root.classList.remove('is-busy'); cb.disabled = false; });
  });
  // if the shopper removes a perk line themselves, do not add it back automatically this session
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ai-perk-line cart-remove-button');
    if (b) { try { sessionStorage.setItem('ai_perk_off', '1'); } catch (x) {} }
  }, true);
  var busy = false, lastSig = '';
  function sweep() {
    if (busy) return;
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    // 1) only extras left in the cart: remove them
    if (cd.querySelector('[data-ai-ship-only]')) {
      busy = true;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var it = (c.items || []).filter(function (i) { return EXTRA.test(i.url || ''); })[0];
        if (!it) { busy = false; return; }
        return call('/cart/change.js', { id: String(it.key), quantity: 0 }).then(function (s) { busy = false; render(s); });
      }).catch(function () { busy = false; });
      return;
    }
    // 2) perks: swap between the free and the standard variant, and add missing free perks once
    var m = cd.querySelector('[data-ai-perks]');
    if (!m) { lastSig = ''; return; }
    var swaps = String(m.getAttribute('data-swap') || '').split(';').filter(Boolean);
    var adds = String(m.getAttribute('data-add') || '').split(',').filter(Boolean);
    var off = false; try { off = sessionStorage.getItem('ai_perk_off') === '1'; } catch (x) {}
    if (off) adds = [];
    if (!swaps.length && !adds.length) return;
    var sig = swaps.join(';') + '#' + adds.join(',');
    if (sig === lastSig) return; // already tried this exact change, do not loop
    lastSig = sig; busy = true;
    var updates = {}, items = [];
    swaps.forEach(function (s) { var p = s.split('|'); updates[p[0]] = 0; var v = parseInt(p[1], 10); if (v > 0) items.push({ id: v, quantity: 1 }); });
    adds.forEach(function (v) { items.push({ id: parseInt(v, 10), quantity: 1 }); });
    var hasUp = Object.keys(updates).length;
    var run = items.length
      ? (hasUp ? fetch('/cart/update.js', { method: 'POST', headers: HDR, body: JSON.stringify({ updates: updates }) }).then(function (r) { return r.json(); }) : Promise.resolve({}))
          .then(function () { return call('/cart/add.js', { items: items }); })
      : call('/cart/update.js', { updates: updates });
    run.then(function (s) { busy = false; if (s && s.status) return; render(s); })
      .catch(function () { busy = false; });
  }
  var cd0 = document.querySelector('cart-drawer');
  if (cd0 && 'MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () { if (pending) return; pending = true; setTimeout(function () { pending = false; sweep(); }, 50); }).observe(cd0, { childList: true, subtree: true });
  }
  sweep();
})();